module.exports = __webpack_public_path__ + "img/loader-icon.e6e71ca.svg";